import i from "../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import f from "vue";
import c from "./Toast.js";
import { isServer as s, isObject as v } from "../utils/index.js";
import { removeNode as p } from "../utils/dom/node.js";
var d = {
    icon: "",
    type: "text",
    // @deprecated
    mask: !1,
    value: !0,
    message: "",
    className: "",
    overlay: !1,
    onClose: null,
    onOpened: null,
    duration: 2e3,
    iconPrefix: void 0,
    position: "middle",
    transition: "van-fade",
    forbidClick: !1,
    loadingType: void 0,
    getContainer: "body",
    overlayStyle: null,
    closeOnClick: !1,
    closeOnClickOverlay: !1
  },
  l = {},
  t = [],
  o = !1,
  a = i({}, d);
function m(e) {
  return v(e) ? e : {
    message: e
  };
}
function y(e) {
  return document.body.contains(e);
}
function O() {
  if (s) return {};
  if (t = t.filter(function (n) {
    return !n.$el.parentNode || y(n.$el);
  }), !t.length || o) {
    var e = new (f.extend(c))({
      el: document.createElement("div")
    });
    e.$on("input", function (n) {
      e.value = n;
    }), t.push(e);
  }
  return t[t.length - 1];
}
function g(e) {
  return i({}, e, {
    overlay: e.mask || e.overlay,
    mask: void 0,
    duration: void 0
  });
}
function r(e) {
  e === void 0 && (e = {});
  var n = O();
  return n.value && n.updateZIndex(), e = m(e), e = i({}, a, l[e.type || a.type], e), process.env.NODE_ENV === "development" && e.mask && console.warn('[Vant] Toast: "mask" option is deprecated, use "overlay" option instead.'), e.clear = function () {
    n.value = !1, e.onClose && (e.onClose(), e.onClose = null), o && !s && n.$on("closed", function () {
      clearTimeout(n.timer), t = t.filter(function (u) {
        return u !== n;
      }), p(n.$el), n.$destroy();
    });
  }, i(n, g(e)), clearTimeout(n.timer), e.duration > 0 && (n.timer = setTimeout(function () {
    n.clear();
  }, e.duration)), n;
}
var h = function h(n) {
  return function (u) {
    return r(i({
      type: n
    }, m(u)));
  };
};
["loading", "success", "fail"].forEach(function (e) {
  r[e] = h(e);
});
r.clear = function (e) {
  t.length && (e ? (t.forEach(function (n) {
    n.clear();
  }), t = []) : o ? t.shift().clear() : t[0].clear());
};
r.setDefaultOptions = function (e, n) {
  typeof e == "string" ? l[e] = n : i(a, e);
};
r.resetDefaultOptions = function (e) {
  typeof e == "string" ? l[e] = null : (a = i({}, d), l = {});
};
r.allowMultiple = function (e) {
  e === void 0 && (e = !0), o = e;
};
r.install = function () {
  f.use(c);
};
f.prototype.$toast = r;
export { r as default };
